export type metricTypeObject = {
  key: string;
  type: string;
  label: string;
};

function calculateMetrics(metrics: metricTypeObject[], data: any[]) {
  const metricsArr = metrics.map((metric) => {
    const type = metric.type;
    const key = metric.key;
    const value = data.map((value: any) => {
      return value[key] ? value[key] : 0;
    });
    if (type === "max") {
      const max = Math.max(...value);
      return {
        key: metric.key,
        label: metric.label,
        //   units: metric.unit,
        //   fractionDigits: metric.fractionDigits,
        value: max,
      };
    }
    if (type === "min") {
      const min = Math.min(...value);
      return {
        key: metric.key,
        label: metric.label,
        //   units: metric.unit,
        //   fractionDigits: metric.fractionDigits,
        value: min,
      };
    }

    if (type === "sum") {
      const sum = value.reduce((a: number, b: number) => a + b, 0);
      return {
        key: metric.key,
        label: metric.label,
        //   units: metric.unit,
        //   fractionDigits: metric.fractionDigits,
        value: sum,
      };
    }
    if (type === "avg") {
      const avg =
        value.reduce((a: number, b: number) => a + b, 0) / value.length;
      return {
        key: metric.key,
        label: metric.label,
        //   units: metric.unit,
        //   fractionDigits: metric.fractionDigits,
        value: avg,
      };
    }
  });
  return metricsArr;
}

export default calculateMetrics;
